import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Heart, Package } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import ProductCard from '../components/ProductCard';
import ScrollReveal from '../components/ScrollReveal';

export default function WishlistPage() {
  const { items, loading, reloadFull } = useWishlist();
  const { customer, loading: authLoading } = useCustomerAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !customer) navigate('/login');
  }, [authLoading, customer, navigate]);

  useEffect(() => { if (customer) reloadFull(); }, [customer, reloadFull]);

  if (authLoading || loading) {
    return <div className="min-h-screen flex items-center justify-center"><p className="text-black/30 text-sm">Chargement...</p></div>;
  }

  return (
    <div data-testid="wishlist-page" className="pt-24 sm:pt-28 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-black/40 mb-3 flex items-center gap-2">
            <Heart size={12} fill="#B80000" stroke="#B80000" /> Mes Favoris
          </p>
          <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Les soins qui vous font envie
          </h1>
          <p className="mt-3 text-sm text-black/50">
            {items.length === 0 ? 'Votre liste est vide pour le moment.' : `${items.length} produit${items.length > 1 ? 's' : ''} en favoris`}
          </p>
        </div>

        {items.length === 0 ? (
          <div data-testid="wishlist-empty" className="text-center py-20 border border-black/10 bg-[#EDE8DE]/30">
            <Package size={40} strokeWidth={1} className="text-black/15 mx-auto mb-5" />
            <p className="text-black/40 text-sm mb-6">Explorez notre boutique et ajoutez vos coups de cœur</p>
            <Link to="/shop" data-testid="wishlist-shop-cta" className="btn-primary inline-block">Découvrir la boutique</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 sm:gap-x-8 gap-y-14">
            {items.map(product => (
              <ScrollReveal key={product.product_id}>
                <ProductCard product={product} />
              </ScrollReveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
